import type { PaletteOptions } from '@mui/material/styles';

import { colors } from './colors';

export const darkPalette: PaletteOptions = {
    mode: 'dark',

    /**
     * Do not use #402172 directly as the main dark-mode
     * interactive color. It is too dark against our surfaces.
     *
     * #402172 is still the canonical brand/deep state.
     */
    primary: {
        main: colors.brand[500],
        dark: colors.brand[600],
        light: colors.brand[400],
        contrastText: '#FFFFFF',
    },

    /**
     * Real secondary semantic color.
     * Don't use #ffffff08 as secondary.main.
     */
    secondary: {
        main: colors.neutral[500],
        dark: colors.neutral[600],
        light: colors.neutral[400],
        contrastText: '#FFFFFF',
    },

    success: {
        main: colors.status.success.main,
        dark: colors.status.success.strong,
        light: colors.status.success.darkForeground,
        contrastText: '#06150B',
    },

    warning: {
        main: colors.status.warning.main,
        dark: colors.status.warning.strong,
        light: colors.status.warning.darkForeground,
        contrastText: '#181000',
    },

    error: {
        main: colors.status.error.main,
        dark: colors.status.error.strong,
        light: colors.status.error.darkForeground,
        contrastText: '#FFFFFF',
    },

    info: {
        main: colors.status.info.main,
        dark: colors.status.info.strong,
        light: colors.status.info.darkForeground,
        contrastText: '#07151C',
    },

    background: {
        default: colors.dark.background.default,
        paper: colors.dark.background.paper,

        light: colors.dark.background.light,
        extraLight: colors.dark.background.extraLight,
        tab: colors.dark.background.tab,

        chat: {
            primary: colors.dark.chat.primary,
            secondary: colors.dark.chat.secondary,
            button: colors.dark.chat.button,
        },
    },

    text: {
        primary: colors.dark.text.primary,
        secondary: colors.dark.text.secondary,
        light: colors.dark.text.light,

        disabled: colors.dark.text.disabled,
    },

    notification: {
        primary: colors.dark.notification.primary,
        secondary: colors.dark.notification.secondary,
    },

    border: {
        light: colors.dark.border.light,
        main: colors.dark.border.main,
        strong: colors.dark.border.strong,
        error: colors.dark.border.error,
    },

    gradientButton: {
        base: colors.gradients.primaryButton,
        selected: colors.gradients.primaryButtonSelected,
        hover: colors.gradients.primaryButtonHover,
    },

    divider: colors.dark.border.main,

    action: {
        active: colors.dark.text.secondary,

        hover: colors.alpha.white[4],
        hoverOpacity: 0.04,

        selected: colors.alpha.brandDark[16],
        selectedOpacity: 0.16,

        focus: colors.alpha.brandDark[20],
        focusOpacity: 0.2,

        disabled: 'rgba(166, 176, 195, 0.30)',
        disabledBackground: 'rgba(166, 176, 195, 0.08)',
        disabledOpacity: 0.38,
    },
};